import type { FaireProductEntity } from "../../entity_types/product";

export const p_zxurf3jtrh: FaireProductEntity = {
  token: "p_zxurf3jtrh",
  type: "product",
  name: "Chain fringe Zicon inliad 18K Gold Plated SS Earrings - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl: "https://cdn.faire.com/fastly/d0530040f689b6b7461d359421349ffdb6c2f4bda1f03894acfb88fc63e2343d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e6a7f0932bc1901a89bb3c1b3ba9bcea6b0e4b2446de3532a10ef06d9dd4fc49.jpeg",
    "https://cdn.faire.com/fastly/1507c84be2e00bd3d005b1c604089f773a19f3b8fe457dcd0dcccfc3aacc0135.jpeg",
    "https://cdn.faire.com/fastly/abd262f4b8fe34cd31e56aaefa2eddc3189382dffe2ad4c4dcf9e823e9a77b2b.jpeg"
  ],
  priceDollars: 5.97,
  description: "Type: Earrings\nMaterial : Stainless steel ，Zircon，18K gold plated\nSize :20mm*40mm\nProcess: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n★Made of high quality stainless steel,Lead-free,Harmless to Human Body.\n★Perfect jewelry gifts ",
  tags: [],
  msrpDollars: 14.92,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:40.784Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
